import { render, staticRenderFns } from "./cussalerate.vue?vue&type=template&id=1136c1f8&scoped=true&"
import script from "./cussalerate.vue?vue&type=script&lang=js&"
export * from "./cussalerate.vue?vue&type=script&lang=js&"
import style0 from "./cussalerate.vue?vue&type=style&index=0&id=1136c1f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136c1f8",
  null
  
)

export default component.exports